<template>
  <div>
    <v-btn
      id="openFilter"
      outlined
      color="white"
      @click="dialog = true"
    >
      <v-icon color="primary">
        mdi-filter-variant
      </v-icon>
      <span class="button secondary500">{{ buttonLabel }}</span>
    </v-btn>
    <sidebar-dialog
      v-model="dialog"
      :title="title"
    >
      <v-form
        ref="filterTemplateForm"
        class="fill-height"
        @submit.prevent="filter()"
        @keypress.native.enter="filter()"
      >
        <div class="d-flex flex-column justify-space-between fill-height">
          <slot />
          <v-spacer />
          <v-btn
            id="submitFilter"
            color="primary"
            height="48px"
            type="submit"
          >
            <span class="button">APLICAR FILTROS</span>
          </v-btn>
        </div>
      </v-form>
    </sidebar-dialog>
  </div>
</template>

<script>
import SidebarDialog from 'Arch/template/SidebarDialog.vue';

export default {
  name: 'FilterTemplate',
  components: { SidebarDialog },
  props: {
    title: {
      type: String,
      default: 'FILTROS',
    },
    buttonLabel: {
      type: String,
      default: 'FILTROS',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    filter() {
      if (!this.$refs.filterTemplateForm.validate()) {
        return;
      }
      this.$emit('submit');
      this.dialog = false;
    },
  },
};
</script>
